// src/pages/CareersPage.jsx
import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import CareersSection from '../components/CareersSection';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';

// Sample benefits — tweak to your liking
const benefits = [
  {
    title: 'Flexible Hours',
    desc: 'Work when you’re most productive and find the right work–life balance.',
  },
  {
    title: 'Remote-Friendly',
    desc: 'Join us from anywhere—our teams span the globe.',
  },
  {
    title: 'Professional Growth',
    desc: 'Access trainings, conferences, and a mentorship program.',
  },
  {
    title: 'Team Retreats',
    desc: 'Quarterly get-togethers for collaboration, fun, and celebration.',
  },
];

export default function CareersPage() {
  const theme = useTheme();

  return (
  <>
  {/* <Navbar/> */}
  <Box>
      {/* Hero */}
      <Box
        component={motion.div}
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        sx={{
          py: { xs: 8, md: 12 },
          textAlign: 'center',
          bgcolor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h3" fontWeight={700} gutterBottom>
            Careers at Lemda
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.9 }}>
            Join our team of innovators, builders, and problem-solvers.
          </Typography>
        </Container>
      </Box>

      {/* Open Roles */}
      <CareersSection />


    </Box>

  {/* <Footer/> */}
  
  </>
  );
}
